export default __webpack_public_path__ + "e47c83c6a85c4848b057ec50d32d2b8b.png";